module.exports = __webpack_public_path__ + "img/YJ.3499bcdb.png";